import React from 'react'
import { colorTheme, colorWhite } from '@homepages/shared/styles/variables'

import Layout from '../components/LayoutNew'
import SEO from '../components/seo'
import HomeSection3 from '../containers/HomeSection3'
import gongsiIcon from '../components/LayoutNew/icon/gongsi.svg'

import './report.scss'

const ReportPage = () => {
  return (
    <Layout
      className="report-page"
      headerBackground={colorWhite}
      fontColor={colorTheme}
    >
      <SEO
        title="举报渠道"
        description="再惠举报渠道，所有渠道均承诺对举报信息严格保密"
      />
      <div className="report-channel">
        <div className="report-header">
          <h1 className="report-title">举报渠道</h1>
          <p className="report-subtitle">所有渠道均承诺对举报信息严格保密</p>
        </div>

        <div className="report-content">
          <div className="report-card">
            <div className="report-card-icon">
              <i className="iconfont z-icon_mail"></i>
            </div>
            <div className="report-card-info">
              <h3 className="report-card-title">举报专用电子邮箱</h3>
              <a className="report-card-link" href="mailto:12345@kezaihui.com">
                12345@kezaihui.com
              </a>
              <p className="report-card-note">
                针对法务团队的举报，请发送邮件至：
                <a href="mailto:ic@kezaihui.com">ic@kezaihui.com</a>
              </p>
            </div>
          </div>

          <div className="report-card">
            <div className="report-card-icon">
              <img src={gongsiIcon} alt="地址" className="report-card-svg" />
            </div>
            <div className="report-card-info">
              <h3 className="report-card-title">举报文件邮寄地址</h3>
              <p className="report-card-address">
                上海市普陀区中江路118弄22号海亮大厦A座1405室
              </p>
              <p className="report-card-note">收件人：法务（保密）</p>
            </div>
          </div>

          <div className="report-card">
            <div className="report-card-icon">
              <i className="iconfont z-icon_phone"></i>
            </div>
            <div className="report-card-info">
              <h3 className="report-card-title">举报热线电话</h3>
              <a className="report-card-link" href="tel:021-60523213">
                021-60523213
              </a>
            </div>
          </div>
        </div>
      </div>
      <HomeSection3 />
    </Layout>
  )
}

export default ReportPage
